import Core from '../Core'

export default class Event {
  constructor (type) {
    this._type = type
    this._subsribedCallbacks = []
  }
  getType () {
    return this._type
  }
  subscribe (callback) {
    if (typeof callback !== 'function') {
      Core.logger.error('callback must be a function')
      return false
    }
    this._subsribedCallbacks.push(callback)
    return true
  }
  trigger () {
    for (const callback in this._subsribedCallbacks) {
      callback()
    }
  }
}
